import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import { Legend } from '../../../../../common/chart/legend'
import { getUnique } from '../../../../../helpers/common'
import { valToPercent } from '../../../../../helpers/value'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../helper'
import { TREND_DATA } from './constant'
import { selectDataViewByTrend } from './store/slice'

const Trend = ({ isDynamicReport, id }) => {
  const chartId = useRef(getUnique())

  const locale = useSelector((state) => state.i18n.locale)
  const dataByTrend = useSelector(selectDataViewByTrend)

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="pt2 flexColumn"
    >
      <div className="dFlex h100">
        <ChartContainer
          chartId={chartId.current}
          data={dataByTrend}
          margin={{
            top: 10,
            bottom: 0,
            left: isDynamicReport ? 16 : 0,
            right: isDynamicReport ? 16 : 0,
          }}
          width={'70%'}
          height={'100%'}
          xAxis={[{ dataKey: 'year', height: 30 }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: TREND_DATA.map((item) => item.value),
              isBarChart: true,
              tickFormatter: (value) => valToPercent(value, locale),
            },
          ]}
          tooltip={{
            schema: {
              content: [
                ...TREND_DATA.map((bar) => ({
                  dataKey: bar.value,
                  label: I18n.t(bar.title),
                  formatValue: (value) => valToPercent(value, locale),
                })),
              ],
            },
          }}
        >
          {TREND_DATA.map((bar) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              maxBarSize={35}
            />
          ))}
        </ChartContainer>
        <div className="h100 w30 px1 py1 dFlex alignItemsCenter justifyContentCenter">
          <Legend
            chartId={chartId.current}
            items={TREND_DATA.map((item) => ({
              title: item.title,
              value: item.value,
              dataKey: item.value,
              color: item.color,
              isCheckbox: false,
              isI18n: true,
              isDynamicReport: isDynamicReport,
            }))}
            className="flexColumn"
          />
        </div>
      </div>
    </div>
  )
}

export default Trend
